import moment from 'moment';
import { map, groupBy } from 'lodash/fp';

export default picklist => {
  const time = moment().format('x');
  const { id, trackingMethod, categories, items, ...body } = picklist;
  const itemsByCategory = groupBy('categoryId', items);
  return {
    ...body,
    name: `${picklist.name} Copy-${time}`,
    trackingMethodId: trackingMethod.id,
    categories: map(
      each => ({ ...each, items: itemsByCategory[each.id] }),
      categories
    )
  };
};
